import { render, staticRenderFns } from "./LicenseBanner.vue?vue&type=template&id=6a31faa3&scoped=true"
import script from "./LicenseBanner.vue?vue&type=script&lang=js"
export * from "./LicenseBanner.vue?vue&type=script&lang=js"
import style0 from "./LicenseBanner.vue?vue&type=style&index=0&id=6a31faa3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a31faa3",
  null
  
)

export default component.exports